// extracted by mini-css-extract-plugin
export var logo = "_4r-2";
export var logoWrapper = "_4r-1";
export var strip = "_4r-0";